<template>
    <div class="alert danger fx-shake">
        <slot>Error</slot>
    </div>
</template>
